import React, { useEffect, useState } from "react";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { Link, useLocation } from "react-router-dom";
import Http from "../../../Common/Http";
import DatatableFunc from "../../../Common/DatatableFunc";
import Alert from "../../../Common/Alert";

const ShopList = () => {
  const location = useLocation();
  const [shopData, setShopData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/shops`);
      const resRole = await Http.get(`/staff-type-check`);
      
      // Transform the data to convert boolean status to string format expected by ReactDataTable
      const transformedData = res.data.data.map(item => ({
        ...item,
        status: item.status === true || item.status === 1 ? "active" : "inactive"
      }));
      
      setShopData(transformedData);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    
    if (location.state) {
      setAlert({
        message: location.state.message,
        type: location.state.type,
      });
    }
  }, [location.state]);
  const cols = [
    { field: "name", header: "Shop Name" },
    { field: "balance", header: "Balance" },
    { field: "address", header: "Address" },
    { field: "status", header: "Status" }
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={`/view-shop/${item.id}`}
          className="btn btn-info btn-sm ms-1"
          title="View Shop"
        >
          <i className="fa fa-eye" aria-hidden="true"></i>
        </Link>
        {(role === "admin" || role === "accounts") && (
          <Link
            to={`/edit-shop/${item.id}`}
            className="btn btn-primary btn-sm ml-1"
            title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        )}
        {(role === "admin" || role === "accounts") && (
          <button
            className="btn btn-danger btn-sm ml-1"
            title="Delete"
            onClick={() => handleDelete(item.id)}
          >
            <i className="fa fa-trash" aria-hidden="true"></i>
          </button>
        )}
      </td>
    );
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this shop?")) {
      try {
        const res = await Http.delete(`/accounts/shops/${id}`);
        setAlert({
          message: res.data.message,
          type: "success",
        });
        fetchData(); // Refresh the data
      } catch (error) {
        setAlert({
          message: error.response?.data?.message || "Error deleting shop",
          type: "error",
        });
      }
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Shops</h5>
            <div className="am-right">
              {(role === "admin" || role === "accounts") && (
                <Link
                  to="/create-shop"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Shop
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={shopData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopList;